<template>
  <div class="bg-FFFFFF fb fb-col">
    <div class="p-12-0 pl-16 bb fb fb-cross-center">
      <div class="item-flex-1" @click="methodSelectedPeriodStart">
        <div class="font-30 c-171A1D-40">开始日期</div>
        <div
          class="font-36 mt-6 mb-2 text-bold-500"
          :class="computedStartDate ? 'c-171A1D' : 'c-171A1D-40'"
          >{{ computedStartDate || '请选择' }}</div
        >
      </div>
      <div class="item-flex-1 fb fb-cross-center fb-main-center">
        <i class="iconfont c-191F25-28 font-100">&#xe60c;</i>
      </div>
      <div class="item-flex-1" @click="methodSelectedPeriodEnd">
        <div class="font-30 c-171A1D-40">结束日期</div>
        <div
          class="font-36 mt-6 mb-2 text-bold-500"
          :class="computedEndDate ? 'c-171A1D' : 'c-171A1D-40'"
          >{{ computedEndDate || '请选择' }}</div
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    startDimDay: {
      type: [String, Number],
      default: ''
    },
    endDimDay: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    computedStartDate() {
      let date = this.startDimDay + ''
      if (!date) {
        return ''
      }
      if (date.includes('-')) {
        return this.startDimDay.replace(/-/gi, '.')
      }
      let dateText =
        date.slice(0, 4) + '.' + date.slice(4, 6) + '.' + date.slice(6, 8)
      return dateText
    },
    computedEndDate() {
      let date = this.endDimDay + ''
      if (!date) {
        return ''
      }
      if (date.includes('-')) {
        return this.endDimDay.replace(/-/gi, '.')
      }
      let dateText =
        date.slice(0, 4) + '.' + date.slice(4, 6) + '.' + date.slice(6, 8)
      return dateText
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    methodSelectedPeriodStart() {
      this.$emit('methodSelectedPeriodStart')
    },
    methodSelectedPeriodEnd() {
      this.$emit('methodSelectedPeriodEnd')
    }
  }
}
</script>

<style lang="scss" scoped></style>
